import gql from "graphql-tag";

const ACTIVATE_JOB_CARD_BY_PRIMAVERA_DETAILS_MUTATION = gql`
  mutation activateJobCard($affiliate: String, $input: PrimaveraInput!) {
    activateJobCard(affiliate: $affiliate, input: $input)
  }
`;

export { ACTIVATE_JOB_CARD_BY_PRIMAVERA_DETAILS_MUTATION };
